import { createContext, Dispatch } from "react"

export interface BannerReducerProps {
  color: string
  background: string
  visible: boolean
  content: string
}

export const initialState = {
  color: "",
  background: "",
  visible: false,
  content: "",
}

export interface BannerContextProps {
  bannerState: BannerReducerProps
  dispatch: Dispatch<any>
}

const BannerContext = createContext<BannerContextProps>({
  bannerState: initialState,
  dispatch: () => {},
})

export const BannerReducer = (state: any, action: any) => {
  switch (action) {
    case "development": {
      return {
        color: "white",
        background: "var(--color-success)",
        visible: true,
        content: "banner.developmentMessage",
      }
    }
    case "staging": {
      return {
        color: "white",
        background: "var(--color-accent2)",
        visible: true,
        content: "banner.stagingMessage",
      }
    }
    case "maintenance": {
      return {
        color: "white",
        background: "var(--color-error)",
        visible: true,
        content: "banner.maintenanceMessage",
      }
    }
    case "production": {
      return initialState
    }
    default:
      return state
  }
}

export default BannerContext
